// extracted by mini-css-extract-plugin
export default {"wrapper":"FootprintSelect_wrapper__65EFT","input":"FootprintSelect_input__ktM-2","inputDark":"FootprintSelect_inputDark__b+WJA"};